"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MessageDate = void 0;
var _react = _interopRequireDefault(require("react"));
var _dateutil = require("../../../helpers/dateutil");
var _styles = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
var MessageDate = exports.MessageDate = function MessageDate(_ref) {
  var timestamp = _ref.timestamp;
  var date = (0, _dateutil.prettyDateFormat)(timestamp);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.Container, {
    children: date
  });
};